import React, { useCallback, useEffect, useRef, useState } from "react";
import pinned from "../assets/images/Pinned.svg";
import unpinned from "../assets/images/Unpin.svg";
import { CONFIG_COMPONENT_NAME } from "../services/configComponent";
import { default as infoIcon } from "../assets/images/Info icon.svg";
import { default as InfrastructureImg } from "../assets/images/Infrastructure.svg";
import { default as InputsImg } from "../assets/images/Input.svg";
import { Dropdown, Form, Overlay, Tooltip, InputGroup, Modal, Button } from "react-bootstrap";
import { Editor } from "@monaco-editor/react";
import { toast } from "react-toastify";
import WorflowDescription from "../component/common-component/WorflowDescription";
import { commonservices } from "../services/CommonServices";
import addicon from "../assets/images/addicon.svg";
import codeIcon from "../assets/images/code.svg";
const WorkFlowMachineSetupModel = ({
    selectedNode,
    activeRightSidePinnedPanel,
    NewMachineInfo,
    activeTab,
    state,
    isViewMode,
    FnForsetActiveRightSidePanel,
    FnForsetActiveRightSidePinnedPanel,
    nodes,
    FnForSetNodes,
    FnForsetSelectedNode,
    FnForSetTrackState,
    ProjectTermList,
    allMachineList,
    parametersforworkflow,
    loop_sample_data,
    edges
}) => {
    const isViewOnly = Boolean(isViewMode || state?.isViewMode);
    const MachineSetupInfo = useRef(null);
    const overlayDesc_Ref = useRef(null);

    const handleOverlay = (e) => {
        let element = document.getElementById(e?.currentTarget?.id);
        if (element) {
            if (element.classList.contains("overlay-isopen")) {
                element.classList.remove("overlay-isopen");
            } else {
                element.classList.add("overlay-isopen");
            }
        }
    };

    const [workFlowDiscriptionPopupstate, setworkFlowDiscriptionPopupstate] =
        useState(false);
    const [manualLoopKeyByParam, setManualLoopKeyByParam] = useState({});
    const [manualLoopKeyErrorByParam, setManualLoopKeyErrorByParam] = useState({});
    const [openWorkflowDropdownFor, setOpenWorkflowDropdownFor] = useState("");
    const [proxyperrequest, setProxyperrequest] = useState(false);
    const [showCodeEditorModal, setShowCodeEditorModal] = useState(false);
    const [codeEditorParam, setCodeEditorParam] = useState(null);
    const [codeEditorValue, setCodeEditorValue] = useState("");
    const [codeEditorLanguage, setCodeEditorLanguage] = useState("python");

    const handleOpenCodeEditor = (item) => {
        setCodeEditorParam(item);
        setCodeEditorValue(item?.value || "");
        setCodeEditorLanguage("python");
        setShowCodeEditorModal(true);
    };

    const handleSaveCodeEditor = () => {
        if (codeEditorParam) {
            handleNodeFormchange({ target: { value: codeEditorValue } }, codeEditorParam);
            toast.success("Code updated successfully");
        }
        setShowCodeEditorModal(false);
    };

    const workFlowDiscriptionPopup = (e) => {
        if (document.getElementById("body").classList.contains("popup-is-open")) {
            document.getElementById("body").classList.remove("popup-is-open");
            handleOverlay(e);
        } else {
            document.getElementById("body").classList.add("popup-is-open");
        }
        setworkFlowDiscriptionPopupstate(!workFlowDiscriptionPopupstate);
    };

    const normalizeParaType = (type) =>
        String(type || "")
            .toLowerCase()
            .replace(/[^a-z0-9]/g, "");

    const isWorkflowParaCompatible = (machineParaType, workflowParaType) => {
        if (!machineParaType || !workflowParaType) return false;
        return normalizeParaType(machineParaType) === normalizeParaType(workflowParaType);
    };

    const isLoopSampleParaCompatible = (machineParaType, workflowParaType) => {
        if (!machineParaType || !workflowParaType) return false;

        const normalizedMachineType = normalizeParaType(machineParaType);
        const normalizedWorkflowType = normalizeParaType(workflowParaType);
        const textInputTypes = new Set(["textbox", "textarea", "password"]);

        if (
            textInputTypes.has(normalizedMachineType) &&
            textInputTypes.has(normalizedWorkflowType)
        ) {
            return true;
        }

        return normalizedMachineType === normalizedWorkflowType;
    };

    const getConfigParamKey = (item) => item?.machineconfigparaid || item?.parakey || "";

    const handleNodeFormchange = (e, compObj) => {
        let value = e?.target?.value;
        const compObjKey = getConfigParamKey(compObj);

        FnForSetTrackState(true);
        // Create a new updatedConfigData array with new object references
        let updatedConfigData = selectedNode?.configData?.map((item) => {
            const itemKey = getConfigParamKey(item);
            if (itemKey === compObjKey) {

                if (compObj?.paratype === "Dropdown Multiple Select") {
                    value = e;
                }
                else if (compObj?.paratype === "File") {
                    value = selectedNode?.id;
                }

                return {
                    ...item, // Spread the current item's properties
                    value: value,
                    workflowparavalue: "",
                    valuetype: "Manually",
                    filename: compObj?.paratype === "File" ? e.name : "",
                    file: compObj?.paratype === "File" ? e : "",
                };
            }
            return item;
        });
        let Find = updatedConfigData.filter((d) => d.dependson === compObj.parakey);
        if (Find && Find.length > 0) {
            Find.map((item) => {
                if ('value' in item) {
                    item.value = ""
                    item.workflowparavalue = ""
                    item.valuetype = "Manually"
                }
            });
        }

        if (selectedNode.dockerimagename) {

            if (selectedNode?.dockerimagename?.toUpperCase().includes("/LAMBDA:")) {

                if (compObj?.parakey?.toUpperCase() === "FILE") {
                    updatedConfigData = updatedConfigData.map(item => {
                        if (item?.parakey?.toUpperCase() === "PATH") {
                            const isFile = e instanceof File;
                            return {
                                ...item,
                                value: isFile ? selectedNode.id + commonservices.getFileExtension(e.name) : "",
                                workflowparavalue: "",
                                valuetype: "Manually",
                                isdisable: isFile
                            };
                        }
                        return item;
                    });
                }

                else if (compObj?.parakey?.toUpperCase() === "PATH") {
                    updatedConfigData = updatedConfigData.map(item => {
                        if (item?.parakey?.toUpperCase() === "FILE") {
                            return {
                                ...item,
                                value: "",
                                workflowparavalue: "",
                                valuetype: "Manually",
                                filename: "",
                                file: ""
                            };
                        }
                        return item;
                    });
                }
            }
        }

        // Create a new updatedNodes array with new object references
        const updatedNodes = nodes?.map((item) => {
            if (selectedNode?.id === item?.id) {
                return {
                    ...item, // Spread the current node's properties
                    configData: updatedConfigData, // Update the configData
                };
            }
            return item;
        });

        // Update the state with new references
        FnForSetNodes(updatedNodes);
        FnForsetSelectedNode({
            ...selectedNode, // Spread the current selectedNode's properties
            configData: updatedConfigData, // Update the configData
        });
    };

    const handleWorkflowParaSelect = (compObj, workflowPara, valuetype) => {
        if (!compObj?.machineconfigparaid && !compObj?.parakey) return;

        FnForSetTrackState(true);
        const workflowParaName = workflowPara?.name || "";
        const workflowParaType = workflowPara?.inputType || workflowPara?.inputtype || workflowPara?.type;

        const isValidWorkflowSelection =
            valuetype === "Loop Key"
                ? isLoopSampleParaCompatible(compObj?.paratype, workflowParaType)
                : isWorkflowParaCompatible(compObj?.paratype, workflowParaType);

        if (!isValidWorkflowSelection) {
            return;
        }

        if (valuetype === "Loop Key") {
            const compObjKey = getConfigParamKey(compObj);
            if (compObjKey) {
                setManualLoopKeyByParam((prev) => ({
                    ...prev,
                    [compObjKey]: workflowParaName,
                }));
            }
        }

        const updatedConfigData = selectedNode?.configData?.map((item) => {
            const itemKey = getConfigParamKey(item);
            if (itemKey === getConfigParamKey(compObj)) {
                return {
                    ...item,
                    value: "",
                    workflowparavalue: workflowParaName,
                    valuetype: valuetype,
                    filename: "",
                    file: "",
                };
            }
            return item;
        });

        const updatedNodes = nodes?.map((item) => {
            if (selectedNode?.id === item?.id) {
                return {
                    ...item,
                    configData: updatedConfigData,
                };
            }
            return item;
        });

        FnForSetNodes(updatedNodes);
        FnForsetSelectedNode({
            ...selectedNode,
            configData: updatedConfigData,
        });
        setOpenWorkflowDropdownFor("");
    };

    const handleClearWorkflowPara = (compObj) => {
        if (!compObj?.machineconfigparaid && !compObj?.parakey) return;

        FnForSetTrackState(true);
        const workflowParaKey = getConfigParamKey(compObj);
        const updatedConfigData = selectedNode?.configData?.map((item) => {
            const itemKey = getConfigParamKey(item);
            if (itemKey === workflowParaKey) {
                return {
                    ...item,
                    workflowparavalue: "",
                    valuetype: ""
                };
            }
            return item;
        });

        const updatedNodes = nodes?.map((item) => {
            if (selectedNode?.id === item?.id) {
                return {
                    ...item,
                    configData: updatedConfigData,
                };
            }
            return item;
        });

        FnForSetNodes(updatedNodes);
        FnForsetSelectedNode({
            ...selectedNode,
            configData: updatedConfigData,
        });

        if (workflowParaKey) {
            setManualLoopKeyByParam((prev) => ({
                ...prev,
                [workflowParaKey]: "",
            }));
        }
    };

    const handleManualLoopKeyChange = (compObj, value) => {
        const workflowParaKey = getConfigParamKey(compObj);
        if (!workflowParaKey) return;

        setManualLoopKeyByParam((prev) => ({
            ...prev,
            [workflowParaKey]: value,
        }));

        setManualLoopKeyErrorByParam((prev) => ({
            ...prev,
            [workflowParaKey]: "",
        }));
    };

    const handleManualLoopKeyAdd = (compObj) => {
        const workflowParaKey = getConfigParamKey(compObj);
        if (!workflowParaKey) return;

        const manualKey = (manualLoopKeyByParam?.[workflowParaKey] || "").trim();
        if (!manualKey) return;
        if (!manualKey.toLowerCase().startsWith("data")) {
            setManualLoopKeyErrorByParam((prev) => ({
                ...prev,
                [workflowParaKey]: "Key must start with data.",
            }));
            return;
        }

        setManualLoopKeyErrorByParam((prev) => ({
            ...prev,
            [workflowParaKey]: "",
        }));

        handleWorkflowParaSelect(
            compObj,
            {
                name: manualKey,
                inputType: compObj?.paratype,
            },
            "Loop Key"
        );
        setOpenWorkflowDropdownFor("");
    };

    //#region Close ToolTip / Overlays Outside Click ----------------------

    const handleOutsideClick = (event) => {
        if (
            overlayDesc_Ref.current &&
            !overlayDesc_Ref.current.contains(event.target) &&
            !MachineSetupInfo.current.contains(event.target)
        ) {
            workFlowDiscriptionPopup(event); // Close the overlay
        }
    };

    useEffect(() => {
        if (workFlowDiscriptionPopupstate) {
            document.addEventListener("mousedown", handleOutsideClick);
        } else {
            document.removeEventListener("mousedown", handleOutsideClick);
        }

        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [workFlowDiscriptionPopupstate]);

    useEffect(() => {
        if (!selectedNode?.id) return;

        const migratedConfigData = selectedNode?.configData?.map((item) => {
            const workflowParaKey = getConfigParamKey(item);
            const legacyWorkflowParaValue = workflowParaKey
                ? selectedNode?.workflowparavalue?.[workflowParaKey] ||
                selectedNode?.workflowparavalue?.[item?.parakey]
                : "";

            return {
                ...item,
                workflowparavalue:
                    item?.workflowparavalue !== undefined
                        ? item?.workflowparavalue
                        : (legacyWorkflowParaValue || ""),
            };
        });

        if (JSON.stringify(migratedConfigData) === JSON.stringify(selectedNode?.configData)) {
            return;
        }

        const updatedNodes = nodes?.map((item) =>
            item?.id === selectedNode?.id
                ? { ...item, configData: migratedConfigData }
                : item
        );

        FnForSetNodes(updatedNodes);
        FnForsetSelectedNode({
            ...selectedNode,
            configData: migratedConfigData,
        });
    }, [
        selectedNode?.id,
        selectedNode?.configData,
        selectedNode?.workflowparavalue,
        nodes,
        FnForSetNodes,
        FnForsetSelectedNode,
    ]);

    useEffect(() => {
        const nextManualLoopKeys = {};

        (selectedNode?.configData || []).forEach((item) => {
            const workflowParaKey = getConfigParamKey(item);
            const selectedValueType = (item?.valuetype || "").toLowerCase();

            if (
                workflowParaKey &&
                selectedValueType === "loop key" &&
                item?.workflowparavalue
            ) {
                nextManualLoopKeys[workflowParaKey] = item?.workflowparavalue;
            }
        });

        setManualLoopKeyByParam(nextManualLoopKeys);
    }, [selectedNode?.id, selectedNode?.configData]);

    useEffect(() => {
        if (selectedNode?.PROXY_ENABLED === "true") {
            setProxyperrequest(true);
        }
        else {
            setProxyperrequest(false);
        }
    }, [selectedNode?.PROXY_ENABLED]);

    const updateNodeValues = useCallback(
        (e, field) => {
            const newValue = e.target.value;
            FnForSetTrackState(true);

            const updatedNodes = nodes?.map((node) =>
                node.id === selectedNode?.id
                    ? { ...node, [field]: newValue }
                    : node
            );

            if (JSON.stringify(updatedNodes) !== JSON.stringify(nodes)) {
                FnForSetNodes(updatedNodes);
                FnForsetSelectedNode({
                    ...selectedNode,
                    [field]: newValue,
                });
            }
        },
        [nodes, selectedNode, FnForSetNodes, FnForsetSelectedNode, FnForSetTrackState]
    );
    //#endregion ----------------------

    return (
        <div className="project-view-summary-sec-main project-view-cost-summary-sec-main">
            {selectedNode ? (
                <>
                    <div className="summary-title cursor-pointer">
                        <div className="d-flex gap-2">
                            <div
                                className="machine-para-header text-center"
                                onClick={() =>
                                    FnForsetActiveRightSidePanel(activeRightSidePinnedPanel)
                                }
                            >
                                {commonservices.truncateText(NewMachineInfo.name, 25)}
                            </div>
                            <span
                                className="machineinfoicon"
                                style={{
                                    cursor: "pointer",
                                }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleOverlay(e);
                                    setworkFlowDiscriptionPopupstate(
                                        !workFlowDiscriptionPopupstate
                                    );

                                    workFlowDiscriptionPopup();
                                }}
                                ref={MachineSetupInfo}
                            >
                                <img src={infoIcon} alt="infoIcon" />
                            </span>
                        </div>
                        {workFlowDiscriptionPopupstate ? (
                            <>
                                <Overlay
                                    ref={overlayDesc_Ref}
                                    target={MachineSetupInfo.current}
                                    show={workFlowDiscriptionPopupstate}
                                    placement="bottom"
                                >
                                    {(props) => (
                                        <Tooltip id="overlay-example" {...props}>
                                            <WorflowDescription
                                                handleshowPopup={workFlowDiscriptionPopup}
                                                data={NewMachineInfo?.desc}
                                            />
                                        </Tooltip>
                                    )}
                                </Overlay>
                            </>
                        ) : (
                            ""
                        )}

                        {!isViewMode && (
                            <img
                                className="workflow-pin-icon"
                                src={activeRightSidePinnedPanel === "machine" ? pinned : unpinned}
                                alt="analatics"
                                onClick={() =>
                                    activeRightSidePinnedPanel === "machine"
                                        ? FnForsetActiveRightSidePinnedPanel("sm-panel")
                                        : FnForsetActiveRightSidePinnedPanel("machine")
                                }
                            />
                        )}
                    </div>
                    <div className="starter-input-data">
                        <h3><img src={InputsImg} alt="input" />Inputs</h3>
                        <form className="form-section-form">
                            {activeTab === 0 ? (
                                <div className="flow-key-benifits-main">
                                    <Form.Label className="common-label">PROXY Enabled</Form.Label>
                                    <Form.Select
                                        aria-label="Please Select PROXY"
                                        value={selectedNode?.PROXY_ENABLED || false}
                                        onChange={(e) => updateNodeValues(e, "PROXY_ENABLED")}
                                        className="common-select mb-2"
                                        disabled={isViewOnly}
                                    >
                                        <option value={false}>False</option>
                                        <option value={true}>True</option>
                                    </Form.Select>
                                    {proxyperrequest === true && (
                                        <>
                                            <Form.Label className="common-label">PROXY Rotate Per Request</Form.Label>
                                            <Form.Select
                                                aria-label="Please Select PROXY Rotate Per Request"
                                                value={selectedNode?.PROXY_ROTATE_PER_REQUEST ?? true}
                                                onChange={(e) => updateNodeValues(e, "PROXY_ROTATE_PER_REQUEST")}
                                                className="common-select mb-2"
                                                disabled={isViewOnly}
                                            >
                                                <option value={false}>False</option>
                                                <option value={true}>True</option>
                                            </Form.Select>
                                        </>
                                    )}
                                    {(() => {
                                        const NewNodeData = commonservices.TopOlogicalSort(nodes, edges) || [];
                                        const loopStartIndex = NewNodeData.findIndex(
                                            (node) => node?.shortName === "loopstart-0-0-0"
                                        );
                                        const loopEndIndex = NewNodeData.findIndex(
                                            (node) => node?.shortName === "loopend-0-0-0"
                                        );
                                        const selectedNodeIndex = NewNodeData.findIndex(
                                            (node) => node?.id === selectedNode?.id
                                        );

                                        const isSelectedNodeInsideLoopRange =
                                            loopStartIndex !== -1 &&
                                            loopEndIndex !== -1 &&
                                            selectedNodeIndex !== -1 &&
                                            selectedNodeIndex > loopStartIndex &&
                                            selectedNodeIndex < loopEndIndex;

                                        return selectedNode?.configData?.map((item) => {
                                            let parentValue = "";
                                            let dependson = item?.dependson ? item?.dependson : "";
                                            let dependsonvalue = item?.dependsonvalue ? "," + item?.dependsonvalue + "," : "";
                                            let ishide = "";

                                            if (dependson) {
                                                let Find = selectedNode?.configData.filter((x) => x.parakey === dependson);
                                                if (Find && Find.length > 0) {
                                                    if (Find[0].value) {
                                                        parentValue = Find[0].value;
                                                    }
                                                }
                                            }

                                            if (dependson && dependsonvalue) {
                                                if (parentValue) {
                                                    if (dependsonvalue.indexOf("," + parentValue + ",") < 0) {
                                                        ishide = "dependsonhide";
                                                    }
                                                }
                                                else {
                                                    ishide = "dependsonhide";
                                                }
                                            }
                                            let isDisable = false;
                                            if (state?.isViewMode || isViewOnly) {
                                                isDisable = true;
                                            }

                                            if (item.isdisable) {
                                                isDisable = true;
                                            }

                                            const selectedWorkflowParaName = item?.workflowparavalue || "";
                                            const selectedValueType = item?.valuetype || "";
                                            const isLoopKeySelected = selectedValueType.toLowerCase() === "loop key";
                                            const compObjKey = getConfigParamKey(item);
                                            const manualLoopKeyValue =
                                                manualLoopKeyByParam?.[compObjKey] ||
                                                (isLoopKeySelected ? selectedWorkflowParaName : "");

                                            const matchedWorkflowParameters = (parametersforworkflow || []).filter((para) =>
                                                isWorkflowParaCompatible(
                                                    item?.paratype,
                                                    para?.inputType || para?.inputtype || para?.type,
                                                )
                                            );

                                            const loopParameters = isSelectedNodeInsideLoopRange
                                                ? (loop_sample_data || []).filter((para) =>
                                                    isLoopSampleParaCompatible(
                                                        item?.paratype,
                                                        para?.inputType || para?.inputtype || para?.type,
                                                    )
                                                )
                                                : [];

                                            const canUseManualLoopKey = isSelectedNodeInsideLoopRange;

                                            const isWorkflowParaSelected = Boolean(selectedWorkflowParaName);
                                            const isCodeContentParam = item?.parakey?.toLowerCase() === "code_content";

                                            return (<div className={`${ishide}`} dependson={dependson} dependsonvalue={dependsonvalue} parakey={item?.parakey}>
                                                {
                                                    React.createElement(
                                                        CONFIG_COMPONENT_NAME[item?.paratype]
                                                            ? CONFIG_COMPONENT_NAME[item?.paratype]
                                                            : CONFIG_COMPONENT_NAME["Text Box"],
                                                        {
                                                            compObj: item,
                                                            handleChange: handleNodeFormchange,
                                                            isDisable: isDisable || isWorkflowParaSelected,
                                                            nodeContext: {
                                                                selectedNode,
                                                                nodes,
                                                                edges,
                                                                allMachineList,
                                                            },
                                                            labelAction: (
                                                                <div className="d-flex align-items-center gap-2 ms-auto">
                                                                    {isCodeContentParam && (
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-primary btn-sm py-0 px-2 d-flex align-items-center gap-1 code-editor-open-btn"
                                                                            style={{
                                                                                fontSize: "11px",
                                                                                lineHeight: "20px",
                                                                                height: "22px",
                                                                                borderRadius: "4px",
                                                                                fontWeight: 500,
                                                                                cursor: "pointer",
                                                                                whiteSpace: "nowrap"
                                                                            }}
                                                                            title="Open in Code Editor"
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                handleOpenCodeEditor(item);
                                                                            }}
                                                                        >
                                                                            <img
                                                                                src={codeIcon}
                                                                                alt="code"
                                                                                style={{ width: "12px", height: "12px" }}
                                                                            />
                                                                            <span>Code Editor</span>
                                                                        </button>
                                                                    )}
                                                                    <Dropdown
                                                                        align="end"
                                                                        drop="up"
                                                                        popperConfig={{ strategy: "fixed" }}
                                                                        show={openWorkflowDropdownFor === compObjKey}
                                                                        onToggle={(nextShow) =>
                                                                            setOpenWorkflowDropdownFor(nextShow ? compObjKey : "")
                                                                        }
                                                                    >
                                                                        <Dropdown.Toggle
                                                                            variant="link"
                                                                            className="p-0 text-decoration-underline workflow-para-dropdown-toggle"
                                                                            disabled={
                                                                                isDisable || (matchedWorkflowParameters.length === 0 && loopParameters.length === 0 && !canUseManualLoopKey)
                                                                            }
                                                                        >
                                                                            {selectedWorkflowParaName || "Select Global Parameter"}
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu className="workflow-para-dropdown-menu">
                                                                            {matchedWorkflowParameters.length > 0 || loopParameters.length > 0 || canUseManualLoopKey ? (
                                                                                <>
                                                                                    {
                                                                                        matchedWorkflowParameters.length > 0 &&
                                                                                        <>
                                                                                            <div className="workflow-para-dropdown-menu-header">Global Parameters</div>
                                                                                            <>
                                                                                                {
                                                                                                    matchedWorkflowParameters.map((para) => (
                                                                                                        <Dropdown.Item
                                                                                                            key={para?.name}
                                                                                                            onClick={() => handleWorkflowParaSelect(item, para, "Global Parameter")}
                                                                                                        >
                                                                                                            {para?.name}
                                                                                                        </Dropdown.Item>
                                                                                                    ))

                                                                                                }
                                                                                            </>
                                                                                        </>
                                                                                    }
                                                                                    {canUseManualLoopKey && (
                                                                                        <>
                                                                                            {matchedWorkflowParameters.length > 0 && <hr />}
                                                                                            <div className="workflow-para-dropdown-menu-header">Loop Parameters</div>
                                                                                            {
                                                                                                loopParameters.length > 0 &&
                                                                                                <>
                                                                                                    {

                                                                                                        loopParameters.map((para) => (
                                                                                                            <Dropdown.Item
                                                                                                                key={para?.name}
                                                                                                                onClick={() => handleWorkflowParaSelect(item, para, "Loop Key")}
                                                                                                            >
                                                                                                                {para?.name}
                                                                                                            </Dropdown.Item>
                                                                                                        ))
                                                                                                    }
                                                                                                </>
                                                                                            }
                                                                                            <InputGroup className="loop-para-manual-key-input">
                                                                                                <Form.Control
                                                                                                    placeholder="Enter a Manual Key"
                                                                                                    value={manualLoopKeyValue}
                                                                                                    isInvalid={Boolean(manualLoopKeyErrorByParam?.[compObjKey])}
                                                                                                    disabled={isDisable || isViewOnly}
                                                                                                    onChange={(e) => handleManualLoopKeyChange(item, e?.target?.value || "")}
                                                                                                    onKeyDown={(e) => {
                                                                                                        if (e.key === "Enter") {
                                                                                                            e.preventDefault();
                                                                                                            if (!isDisable && !isViewOnly) {
                                                                                                                handleManualLoopKeyAdd(item);
                                                                                                            }
                                                                                                        }
                                                                                                    }}
                                                                                                />
                                                                                                <InputGroup.Text
                                                                                                    id="basic-addon1"
                                                                                                    className={isDisable || isViewOnly ? "opacity-50 pe-none" : "cursor-pointer"}
                                                                                                    onClick={() => !isDisable && !isViewOnly && handleManualLoopKeyAdd(item)}
                                                                                                >
                                                                                                    <img
                                                                                                        src={addicon}
                                                                                                        alt="add"
                                                                                                        className="cursor-pointer"
                                                                                                    />
                                                                                                </InputGroup.Text>

                                                                                            </InputGroup>
                                                                                            {manualLoopKeyErrorByParam?.[compObjKey] && (
                                                                                                <div className="text-danger">
                                                                                                    {manualLoopKeyErrorByParam?.[compObjKey]}
                                                                                                </div>
                                                                                            )}

                                                                                        </>
                                                                                    )}
                                                                                </>
                                                                            ) : (
                                                                                <Dropdown.Item disabled>
                                                                                    No matching workflow parameters
                                                                                </Dropdown.Item>
                                                                            )}
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                    {selectedWorkflowParaName && (
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-link p-0 text-decoration-underline workflow-para-clear-btn"
                                                                            onClick={() => handleClearWorkflowPara(item)}
                                                                            disabled={isDisable}
                                                                        >
                                                                            Clear
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            )
                                                        }
                                                    )
                                                }

                                            </div>)
                                        });
                                    })()}
                                </div>
                            ) : (
                                <></>
                            )}
                        </form>
                    </div>
                    {
                        allMachineList?.dataList1?.filter(
                            (a) =>
                                a.assemblyname === selectedNode?.shortName &&
                                a.assemblyname !== "Starter" &&
                                a?.isdefault === true
                        )?.length > 0 ? (
                            <></>
                        ) : (
                            <>
                                <div className="starter-input-data">
                                    <h3>
                                        <img src={InfrastructureImg} alt="Infra structure" />
                                        Infrastructure
                                    </h3>
                                    <Form.Label className="common-label">RAM</Form.Label>
                                    <Form.Select
                                        aria-label="Default select example"
                                        value={selectedNode?.ram || 0}
                                        onChange={(e) => updateNodeValues(e, "ram")}
                                        className="common-select mb-2"
                                        disabled={isViewOnly}
                                    >
                                        <option value={0}>Please Select RAM</option>
                                        {ProjectTermList?.RAM?.map((item, index) => {
                                            return (
                                                <option value={item?.term} key={index}>
                                                    {item?.term}
                                                </option>
                                            );
                                        })}
                                    </Form.Select>

                                    <Form.Label className="common-label">CPU</Form.Label>
                                    <Form.Select
                                        aria-label="Default select example"
                                        value={selectedNode?.cpu || 0}
                                        onChange={(e) => updateNodeValues(e, "cpu")}
                                        className="common-select mb-2"
                                        disabled={isViewOnly}
                                    >
                                        <option value={0}>Please Select CPU</option>
                                        {ProjectTermList?.CPU?.map((item, index) => {
                                            return (
                                                <option value={item?.term} key={index}>
                                                    {item?.term}
                                                </option>
                                            );
                                        })}
                                    </Form.Select>
                                </div>
                            </>
                        )
                    }
                </>
            ) : (
                <div className="summary-title">
                    {" "}
                    <div className="text-center">Please select machine</div>
                    {!isViewMode && (
                        <img
                            className="workflow-pin-icon"
                            src={activeRightSidePinnedPanel === "machine" ? pinned : unpinned}
                            alt="analatics"
                            onClick={() =>
                                activeRightSidePinnedPanel === "machine"
                                    ? FnForsetActiveRightSidePinnedPanel("sm-panel")
                                    : FnForsetActiveRightSidePinnedPanel("machine")
                            }
                        />
                    )}
                </div>
            )}
            {/* </div> */}

            {showCodeEditorModal && (
                <Modal
                    show={showCodeEditorModal}
                    onHide={() => setShowCodeEditorModal(false)}
                    centered
                    size="xl"
                    backdrop="static"
                    keyboard={true}
                    className="workflow-code-editor-modal"
                >
                    <Modal.Header closeButton style={{ borderBottom: "1px solid #dee2e6", padding: "12px 20px" }}>
                        <div className="d-flex align-items-center justify-content-between w-100 me-3">
                            <div className="d-flex align-items-center gap-2">
                                <span
                                    className="d-flex align-items-center justify-content-center"
                                    style={{
                                        width: "28px",
                                        height: "28px",
                                        borderRadius: "6px",
                                        backgroundColor: "#e6f0f9",
                                        color: "#0461bb",
                                    }}
                                >
                                    <img src={codeIcon} alt="code" style={{ width: "16px", height: "16px" }} />
                                </span>
                                <div>
                                    <Modal.Title style={{ fontSize: "16px", fontWeight: "600", margin: 0, lineHeight: 1.2 }}>
                                        Code Editor
                                    </Modal.Title>
                                    <small className="text-muted" style={{ fontSize: "12px" }}>
                                        {selectedNode?.workflowmachinename || selectedNode?.name || "Machine"} &bull; {codeEditorParam?.parakey?.replaceAll("_", " ") || "code content"}
                                    </small>
                                </div>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <Form.Select
                                    size="sm"
                                    value={codeEditorLanguage}
                                    onChange={(e) => setCodeEditorLanguage(e.target.value)}
                                    style={{ width: "130px", fontSize: "12px" }}
                                    disabled={isViewOnly}
                                >
                                    <option value="python">Python</option>
                                    <option value="javascript">JavaScript</option>
                                    <option value="json">JSON</option>
                                    <option value="shell">Shell</option>
                                    <option value="plaintext">Plain Text</option>
                                </Form.Select>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body style={{ padding: 0, backgroundColor: "#1e1e1e" }}>
                        <Editor
                            height="60vh"
                            language={codeEditorLanguage}
                            theme="vs-dark"
                            value={codeEditorValue}
                            onChange={(val) => setCodeEditorValue(val || "")}
                            options={{
                                readOnly: isViewOnly,
                                minimap: { enabled: true },
                                fontSize: 13,
                                lineNumbers: "on",
                                automaticLayout: true,
                                scrollBeyondLastLine: false,
                                tabSize: 4,
                                wordWrap: "on",
                            }}
                            onMount={(editor, monaco) => {
                                editor.focus();
                                editor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyS, () => {
                                    if (!isViewOnly) {
                                        handleSaveCodeEditor();
                                    }
                                });
                            }}
                        />
                    </Modal.Body>
                    <Modal.Footer style={{ borderTop: "1px solid #dee2e6", padding: "10px 20px" }}>
                        <div className="d-flex align-items-center justify-content-between w-100">
                            <div className="text-muted" style={{ fontSize: "12px" }}>
                                {!isViewOnly ? (
                                    <span>Tip: Press <kbd>Ctrl</kbd> + <kbd>S</kbd> to save</span>
                                ) : (
                                    <span className="text-warning">View Only Mode</span>
                                )}
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    onClick={() => setShowCodeEditorModal(false)}
                                >
                                    {isViewOnly ? "Close" : "Cancel"}
                                </Button>
                                {!isViewOnly && (
                                    <Button
                                        variant="primary"
                                        size="sm"
                                        className="save-changes-btn"
                                        onClick={handleSaveCodeEditor}
                                    >
                                        Save Changes
                                    </Button>
                                )}
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            )}
        </div >
    );
};

export default WorkFlowMachineSetupModel;
